var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDollar2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.625 12.2666H10.1667C10.7083 12.2666 11.1583 11.7833 11.1583 11.1999C11.1583 10.4749 10.9 10.3333 10.475 10.1833L9.63333 9.8916V12.2666H9.625Z",
    fill: "#0044EB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.97636 0.58351C4.37636 0.600177 0.651358 4.34184 0.668024 8.94184C0.684691 13.5418 4.42636 17.2668 9.02636 17.2502C13.6264 17.2335 17.3514 13.4918 17.3347 8.89184C17.318 4.29184 13.5764 0.575177 8.97636 0.58351ZM10.8847 9.00018C11.5347 9.22518 12.4097 9.70851 12.4097 11.2002C12.4097 12.4835 11.4014 13.5168 10.168 13.5168H9.62636V14.0002C9.62636 14.3418 9.34302 14.6252 9.00136 14.6252C8.65969 14.6252 8.37636 14.3418 8.37636 14.0002V13.5168H8.07636C6.70969 13.5168 5.60136 12.3668 5.60136 10.9502C5.60136 10.6085 5.88469 10.3252 6.22636 10.3252C6.56802 10.3252 6.85136 10.6085 6.85136 10.9502C6.85136 11.6752 7.40136 12.2668 8.07636 12.2668H8.37636V9.45018L7.11802 9.00018C6.46802 8.77518 5.59302 8.29184 5.59302 6.80018C5.59302 5.51684 6.60136 4.48351 7.83469 4.48351H8.37636V4.00018C8.37636 3.65851 8.65969 3.37518 9.00136 3.37518C9.34302 3.37518 9.62636 3.65851 9.62636 4.00018V4.48351H9.92636C11.293 4.48351 12.4014 5.63351 12.4014 7.05018C12.4014 7.39184 12.118 7.67518 11.7764 7.67518C11.4347 7.67518 11.1514 7.39184 11.1514 7.05018C11.1514 6.32518 10.6014 5.73351 9.92636 5.73351H9.62636V8.55018L10.8847 9.00018Z",
    fill: "#0044EB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.85156 6.8084C6.85156 7.5334 7.1099 7.67507 7.5349 7.82507L8.37656 8.11673V5.7334H7.8349C7.29323 5.7334 6.85156 6.21673 6.85156 6.8084Z",
    fill: "#0044EB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDollar2);
export default __webpack_public_path__ + "static/media/icon_dollar_2.b9d5e2a23ae1b7f88c1120e70e399ab3.svg";
export { ForwardRef as ReactComponent };